import React from 'react';
import { I18n } from '@aws-amplify/core';
import Select from '@/components/ui/Select';
import FormItem from '@/components/ui/FormItem';
import { useResolution886Report } from '@/context/Resolution886Report';

interface SelectOptionsProps {
	label: string;
	value: string;
}

interface SelectTaskProps {
	id: string;
	loading: boolean;
	fieldName: string;
	options: SelectOptionsProps[];
	handleInputChange: (event: React.ChangeEvent<HTMLInputElement>) => void;
	addItem: (e: React.MouseEvent<HTMLAnchorElement>) => void;
	onChange: (value: string) => void;
}

export function SelectTask({
	loading,
	options,
	fieldName,
	handleInputChange,
	addItem,
	onChange
}: Readonly<SelectTaskProps>): JSX.Element {
	const { previousReview } = useResolution886Report();

	return (
		<FormItem name={fieldName}>
			<Select.Multiple
				placeholder="Select activity"
				placeholderInput="Enter activity name"
				options={options}
				isSingle
				isAdd={previousReview?.id ? false : true}
				allowClear
				textButton={I18n.get('Add')}
				onInputChange={handleInputChange}
				addItem={addItem}
				onChange={onChange}
				loading={loading}
			/>
		</FormItem>
	);
}
